module.exports = __webpack_public_path__ + "assets/img/丰富活动模板.001d3bba.jpg";